import React, { useEffect, useState } from 'react';
import { Flex } from 'antd';
import { useAppDispatch } from '../utilities/hooks';
import { setterDevelopment } from '../slices/developmentSlice';

export const useDevelopmentMode = () => {
    const dispatch = useAppDispatch();
    const [counterDevelopmentClick, setCounterDevelopmentClick] = useState<number>(0);

    const isDevelopmentMode = () => {
        return counterDevelopmentClick > 10;
    };

    useEffect(() => {
        dispatch(setterDevelopment({ isDevelopmentMode: isDevelopmentMode() }));
    }, [counterDevelopmentClick]);

    const developmentClick = () => {
        setCounterDevelopmentClick((prevValue) => prevValue + 1);
    };

    const developmentLabel = isDevelopmentMode() && (
        <span style={{ color: 'red', fontWeight: 'bold' }}>(Development Mode)</span>
    );

    const wrapperDevelopmentClick = (
        <Flex flex={1} vertical justify={'end'}>
            <Flex onClick={developmentClick} style={{ background: isDevelopmentMode() ? 'red' : 'white', height: 50 }}>
                {' '}
            </Flex>
        </Flex>
    );
    return { developmentClick, isDevelopmentMode: isDevelopmentMode(), developmentLabel, wrapperDevelopmentClick };
};
